import { gql } from '@apollo/client';

const BLOCKED_PHONE_NUMBER_HISTORY = gql`
  query BlockedPhoneNumberHistory(
    $agent: String
    $customerId: String
    $isBlocked: Boolean
    $phoneNumber: String
  ) {
    blockedPhoneNumberHistory(
      agent: $agent
      customerId: $customerId
      isBlocked: $isBlocked
      phoneNumber: $phoneNumber
    ) {
      id
      blockEnd
      blockStart
      customerIds
      insertBy
      isBlocked
      lastModifiedBy
      lastModifiedDate
      phoneNumber
      reasonCode
      reasonDescription
    }
  }
`;

export { BLOCKED_PHONE_NUMBER_HISTORY };
